import { createImageResolver } from '@/utils/images'

const staticGlassMorphIconPathResolver = createImageResolver(
  require.context('../../../../assets/icons/glassmorphism', true, /\.(png|svg|jpg|jpeg|gif|webp)$/i),
  'icons/glassmorphism/',
)

export const getStaticGlassMorphIconPath = (iconName: string) => staticGlassMorphIconPathResolver(`${iconName}.png`)
